import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './LettersBonusPlans.css';

const cx = classnames.bind(styles);

function getStatusText(selectedSubscriptionData, isBonusOn) {
    if (isBonusOn) {
        return `Added to your ${selectedSubscriptionData.billingPeriod?.value}-week plan for free`;
    }

    return selectedSubscriptionData.hasLettersBonus ? 'Turn on to get them for free' : 'Free with the 4-week or 12-week plan';
}

function LettersBonusPlans({ plans, selectedSubscriptionData, isBonusOn, onBonusChange, renderCard }) {
    const offerPlans = plans.filter(plan => plan.hasLettersBonus);
    const otherPlans = plans.filter(plan => !plan.hasLettersBonus);
    const attachedPlan = isBonusOn ? selectedSubscriptionData.plan : null;
    const lettersClassName = cx('letters', {
        attachedToTop: offerPlans[0]?.plan === attachedPlan,
        attachedToBottom: offerPlans[1]?.plan === attachedPlan
    });

    return (
        <>
            <div className={styles.offer}>
                {offerPlans.map((plan, index) => (
                    <Fragment key={plan.plan}>
                        {renderCard(plan, cx('card', {
                            attachedBelow: index === 0 && plan.plan === attachedPlan,
                            attachedAbove: index === 1 && plan.plan === attachedPlan
                        }))}
                        {index === 0 && (
                            <label className={lettersClassName}>
                                <span className={styles.lettersTop}>
                                    <span className={styles.mailBox}>
                                        <Icon name='mail' className={styles.mailIcon} />
                                    </span>
                                    <span className={styles.lettersHeading}>
                                        <span className={styles.lettersTitle}>36 letters to your future self</span>
                                        <span className={styles.lettersPrice}>
                                            <span className={styles.lettersOldPrice}>$17.99</span>
                                            <span className={styles.freeBadge}>FREE</span>
                                        </span>
                                    </span>
                                    <input
                                        type='checkbox'
                                        role='switch'
                                        checked={isBonusOn}
                                        onChange={e => onBonusChange(e.target.checked)}
                                        className={styles.switchInput}
                                    />
                                    <span className={styles.switch} />
                                </span>
                                <span className={styles.lettersBody}>
                                    <span className={styles.lettersDescription}>
                                        Open when you’re happy. Open when it’s hard. Your words, waiting for you.
                                    </span>
                                    <span className={cx('lettersStatus', { added: isBonusOn })}>
                                        {isBonusOn && <Icon name='check' className={styles.statusIcon} />}
                                        {getStatusText(selectedSubscriptionData, isBonusOn)}
                                    </span>
                                </span>
                            </label>
                        )}
                    </Fragment>
                ))}
            </div>
            {otherPlans.map(plan => renderCard(plan))}
        </>
    );
}

LettersBonusPlans.propTypes = {
    plans: PropTypes.array.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    isBonusOn: PropTypes.bool.isRequired,
    onBonusChange: PropTypes.func.isRequired,
    renderCard: PropTypes.func.isRequired
};

export {
    LettersBonusPlans
};
